module.exports = __webpack_public_path__ + "img/im_scrollfeature_06.7d4c23a4.jpg";